import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Orders from "./components/Orders";
import Customers from "./components/Customers";
import EmployeeTasks from "./components/EmployeeTasks";
import ProductionList from "./components/ProductionList";
import DailySummary from "./components/DailySummary";
import WeeklySummary from "./components/WeeklySummary";
import ProductPropertiesUpdate from "./components/ProductPropertiesUpdate";
import OneDrive from "./components/OneDrive";
import Square from "./components/Square";
import NavMenu from "./navigation/NavMenu";
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OrderService from './components/service/OrderService';
import {DecoratorsView, BakersView} from './components/KitchenViews';
import Configure from './components/Configure';

function App() {
  
  return (
    <Router>
      <div className="App">
        <NavMenu />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/BakingStudioManager"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />
          <Route
            path="/BakingStudioManager/orders"
            element={
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/BakingStudioManager/kitchen/bakers"
            element={
              <PrivateRoute>
              <BakersView />
              </PrivateRoute>
            }
          />
          <Route
            path="/BakingStudioManager/kitchen/decorators"
            element={
              <PrivateRoute>
                <DecoratorsView />
              </PrivateRoute>
            }
          /> */}

          <Route
            path="/BakingStudioManager/employee-tasks"
            element={
              <PrivateRoute>
                <EmployeeTasks />
              </PrivateRoute>
            }
          />
          <Route
            path="/BakingStudioManager/weekly-summary"
            element={
              <PrivateRoute>
                <WeeklySummary />
              </PrivateRoute>
            }
          />
          <Route
            path="/BakingStudioManager/production-list"
            element={
              <PrivateRoute>
                <ProductionList />
              </PrivateRoute>
            }
          />
           <Route
            path="/BakingStudioManager/configure"
            element={
              <PrivateRoute>
                <Configure />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;